import { Component } from '@angular/core';
import { TranslateModule } from '@client/app/modules/translate.module';

@Component({
    selector: 'seo-no-index',
    templateUrl: './no-index.component.html',
    standalone: true,
    imports: [TranslateModule],
})
export class SeoNoIndexComponent {
}
